import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import {
  customerServiceTabList,
  termsSubTabList,
} from "../../constant/customerServiceTab";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgBody02 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody02";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import TermApi from "../../api/term.api";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Loading from "../../components/templates/loading";
import { toast } from "react-toastify";

const CustomerServiceTermsPrivacy = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [isLoading, setIsLoading] = useState(true);

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    customerServiceTabList[3].title,
  );

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    termsSubTabList[1].title,
  );

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    getTermData();
  }, []);

  // ---------- 약관 데이터 가져오기 ---------- //
  const [termData, setTermData] = useState({});

  const getTermData = async () => {
    try {
      const response = (await TermApi.getDetail(8)).data.data.content;

      setTermData(response);
    } catch (error) {
      console.error(error);
      toast("개인정보처리방침을 불러오지 못했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📢 고객센터
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {customerServiceTabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 3 ? true : false}
                    title={tab.title}
                  />

                  {index === 3 && (
                    <SubTabWrapper>
                      {termsSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 1 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <ContentContainer>
              <LSBdDisplay02>{termData?.title || ""}</LSBdDisplay02>
              <LSRgBody02
                style={{
                  color: "#404249",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {termData?.content || ""}
              </LSRgBody02>
            </ContentContainer>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>📢 고객센터</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={customerServiceTabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={termsSubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <ContentBodyWrapperMobile>
              <LSBdH1HeadLine>{termData?.title || ""}</LSBdH1HeadLine>
              <LSRgCaption02
                style={{
                  color: "#404249",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {termData?.content || ""}
              </LSRgCaption02>
            </ContentBodyWrapperMobile>
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default CustomerServiceTermsPrivacy;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  background-color: ${(props) => (props.$isSmall ? "" : "#f6f7f8")};
  padding: ${(props) => (props.$isSmall ? "" : "40px")};
  border-radius: ${(props) => (props.$isSmall ? "" : "30px")};
  gap: ${(props) => (props.$isSmall ? "40px" : "30px")};
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;

const ContentBodyWrapperMobile = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f6f7f8;
  border-radius: 15px;
  gap: 30px;
`;
